import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  idToken: string | null;
  expiresAt: number | null;
  studioId: string | null;
  email: string | null;
  setSession: (s: {
    accessToken: string;
    refreshToken?: string;
    idToken?: string;
    expiresIn: number;
    email?: string | null;
  }) => void;
  setStudio: (studioId: string | null) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      idToken: null,
      expiresAt: null,
      studioId: null,
      email: null,
      setSession: ({ accessToken, refreshToken, idToken, expiresIn, email }) =>
        set({
          accessToken,
          refreshToken: refreshToken ?? null,
          idToken: idToken ?? null,
          expiresAt: Date.now() + expiresIn * 1000,
          email: email ?? null,
        }),
      setStudio: (studioId) => set({ studioId }),
      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          idToken: null,
          expiresAt: null,
          studioId: null,
          email: null,
        }),
    }),
    { name: 'lex.office.auth' },
  ),
);
